export default __webpack_public_path__ + "static/media/openai.8be41ecc.png";